import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }

import { ref, defineAsyncComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'indexValidation',
  setup(__props) {

const toltipValidation = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/validation/toltipValidation.vue"))
const browserDefaults = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/validation/browserDefaults.vue"))
const validationForm = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/validation/validationForm.vue"))

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      main: "Form Controls",
      title: "Validation Forms"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(toltipValidation)),
        _createVNode(_unref(browserDefaults)),
        _createVNode(_unref(validationForm))
      ])
    ])
  ], 64))
}
}

})